import React from "react";

export default function AppContainer({ children }) {
  return <div className="container">{children}</div>;
}
